module.exports = __webpack_public_path__ + "img/three-green-fire.26fe3379.svg";